export const phoneFormat = (num: string) => {
  if (Number.isNaN(+num)) {
    return num;
  }
  return num.split('').reverse().join('').replace(/(\d{4})(\d{3})(\d{3})(\d{0,})/, "$1-$2-$3 $4").split('').reverse().join('');
}
